<template minapp='mpx' xlang='wxml'>
  <es-layout
    layout="{{['header', 'footer']}}"
    click-left='{{goback}}'
    class="es-add"
    custom-class="contact-add-custom-class"
  >
    <!-- 导航栏 -->
    <view class="page-header" slot="header">
      <es-navbar class="es-add__navbar" custom-class="es-add__navbar" title="{{'新增' + title + '信息'}}" leftArrow="{{false}}">
        <view wx:if="{{!isHideLeftArrow}}" slot="left">
          <es-icon size='24' color="#333333" name="angle-left"></es-icon>
        </view>
      </es-navbar>
    </view>
    <!-- <view style="height:12px"></view> -->

    <!-- 内容部分 -->
    <es-content
      wx:ref="contentRef"
      source="{{source}}"
      scene="{{scene}}"
      isNeedCard="{{isNeedCard}}"
      category="{{category}}"
      isAddPage="{{true}}"
      isDelay="{{isDelay}}"
      bind:change="changeDialog"
    />
    <!-- bind:updata-view="viewUpdate" -->

    <!-- 保存 -->
    <view slot="footer" class="es-add__footer">
      <es-button block type="info" custom-class="es-add__save" bind:click="saveContact">
        保存
      </es-button>
    </view>

    <es-toast id='es-toast' />
    <es-dialog id="es-dialog" />
  </es-layout>
  <filling-explanation
    show="{{isDialogShow}}"
    bind:close="changeDialog"
  >
  </filling-explanation>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared'
  import { remove, findIndex, difference } from 'lodash'
  import { PageSource, NeedCardType, SceneType } from '@/utils/constants'
  import store from '@/store'
  import { isWXMini, isALIMini } from '@/common/constant'
  import Validator from '@/utils/validator'
  import { titleConfig } from '@/config/content/index'
  import { innerRouter, pagePath } from "@/common/jump";

  createPage({
    data: {
      source: PageSource.common,
      need_card: NeedCardType.yes,
      category: 'train',
      scene: SceneType.forPersonal,
      isDialogShow:false,
      title: '出行人',
      isDelay:false
    },

    computed: {
      ...store.mapState({
        cardTypeList: 'newContacts.cardTypeList'
      }),

      isHideLeftArrow() {
        return isWXMini || isALIMini
      },

      isNeedCard() {
        return this.need_card === NeedCardType.yes
      },
    },

    methods: {
      ...store.mapActions({
        getCardTypeListAction: 'newContacts.getCardTypeListAction',
      }),
      // 删除常用联系人按钮，所以这方法也去掉了
      // contentTap() {
      //   if (this.$refs['contentRef']) {
      //     this.$refs['contentRef'].contentTap()
      //   }
      // },
      
      changeDialog() {
        this.isDialogShow = !this.isDialogShow;
      
        // h5 让所有的输入框失去焦点
        if (__mpx_mode__ === 'web') {
          document.querySelectorAll('input')?.forEach(item => {
            item.blur();
          })
        }
      },

      goback() {
        innerRouter.goback()
      },
      // viewUpdate() {
      //   this.$forceUpdate()
      // },
      saveContact() {
        if (this.$refs['contentRef']) {
          this.$refs['contentRef'].saveContact()
        }
      },
    },
    async mounted() {
      mpx.setNavigationBarColor({ frontColor: '#000000' })
      const { need_card, source, scene, isDelay } = this.$mpxRoute.query
      this.source = source || PageSource.common // 页面来源 1-常用 2-选择
      this.need_card = need_card || NeedCardType.yes // 是否需要证件信息 1-是 0-否
      
      this.title = titleConfig[this.category] // 页面标题
      this.scene = scene || SceneType.forPersonal // 场景
      this.isDelay = Boolean(isDelay)

      this.getCardTypeListAction({ category: this.category, need_card: NeedCardType.yes })
    },
  })
</script>

<style lang='stylus' scoped>
  +b('add')
    /deep/ .es-main
      background-color #f0f1f4
    /deep/ .es-toast
      background-color #000000
      padding 12px 24px
    /deep/ .es-card__body
      padding 0 12px !important
    /deep/ .es-icon-angle-right
      font-size 20px !important
      color #999999 !important
    +e('navbar')
      background-color #ffffff
      height 44px !important
      z-index auto !important
      font-size 18px
      /deep/ .es-navbar
        height 60px
      /deep/ .es-navbar__right
        width 28px
      /deep/ .es-navbar__title
        font-size 18px
    +e('save')
      border-radius 8px !important
      font-size 16px !important
      background-color #FF6400
      border-color #FF6400
      /deep/ button
        border-radius 8px
    +e('footer')
      width 100%
      padding 16px
      background-color #ffffff
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      // z-index 1
</style>

<script name='json'>
  module.exports = {
    // "navigationBarTitleText": "新增出行人信息",
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon/index',
      'es-layout': '@/es-mpx-ui/lib/layout',
      'es-content': './components/content',
      'es-button': '@didi/es-mpx-ui/lib/button/index',
      'es-toast': '@didi/es-mpx-ui/lib/toast/index',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'filling-explanation': './components/filling-explanation',
    },
  }
</script>

